
//定义一个初始化打印插件的构造函数
let customElementTypeProvider = (function () {
    return function (printElementTypeGroup) {
        let PrintElementTypeObjGroup = printElementTypeGroup.map(item => {
            return new hiprint.PrintElementTypeGroup(item.name, item.elementType)
        })

        let addElementTypes = function (context) {
            context.addPrintElementTypes(
                "print",
                PrintElementTypeObjGroup
            );
        };

        return {
            addElementTypes: addElementTypes
        };

    };
})();
export default function initElementTypeProvider(printElementTypeGroup) {
    hiprint.init({
        providers: [new customElementTypeProvider(printElementTypeGroup)]
    });
    hiprint.PrintElementTypeManager.buildByHtml($(".ep-draggable-item"));
}